import {Injectable} from '@angular/core';
import {LoginModel} from '@drl/core/auth/models/login.model';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';

@Injectable()
export class LoginAdapter implements IAdapter<LoginModel> {
  adaptToModel(resp: any): any {
    return resp;
  }
  adaptFromModel(data: LoginModel): any {
    return {
      username: data.username,
      password: data.password,
      clientId: data.clientId,
      clientSecret: data.clientSecret,
      tenantName:data.tenantName
    };
  }
}
